module.exports = __webpack_public_path__ + "img/title6.aa709ad3.png";